// src/pages/orders/adminDiscountsPage.js — discounts / vouchers management (commerce engine)
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Card, CardBody, CardHeader } from "../../components/card/card.jsx";
import { fetchAdminVouchers, saveAdminVoucher, setVoucherActive } from "../../actions/commerce_admin_actions";

export default function AdminDiscounts() {
  const dispatch = useDispatch();
  const { adminVouchers, adminLoading, adminError, adminSaveError } = useSelector((s) => s.commerceAdmin);
  const [code, setCode] = useState("");
  const [kind, setKind] = useState("percent");
  const [val, setVal] = useState("");
  const [scope, setScope] = useState("");

  useEffect(() => { dispatch(fetchAdminVouchers()); }, [dispatch]);

  const create = () => {
    const input = { code, kind, channelScope: scope || null, active: true };
    if (kind === "percent") input.percent = parseInt(val, 10);
    else input.amount = parseFloat(val);
    dispatch(saveAdminVoucher(input));
    setCode(""); setVal(""); setScope("");
  };
  const shown = (v) => (v.kind === "percent" ? `${v.value}%` : `minor ${v.value}`);

  return (
    <div>
      <h1 className="page-header mb-1">Discounts</h1>
      <div className="text-inverse text-opacity-50 mb-3">Vouchers served by the commerce engine</div>
      {adminError ? <div className="alert alert-danger">{adminError}</div> : null}
      {adminSaveError ? <div className="alert alert-warning">Save failed — {adminSaveError}</div> : null}

      <Card className="mb-3">
        <CardHeader>Add a voucher</CardHeader>
        <CardBody>
          <div className="d-flex gap-2 flex-wrap align-items-center">
            <input className="form-control" style={{ maxWidth: 160 }} placeholder="CODE" value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} />
            <select className="form-select" style={{ maxWidth: 130 }} value={kind} onChange={(e) => setKind(e.target.value)}>
              <option value="percent">percent</option>
              <option value="fixed">fixed</option>
            </select>
            <input className="form-control" style={{ maxWidth: 130 }} placeholder={kind === "percent" ? "%" : "amount"} value={val} onChange={(e) => setVal(e.target.value)} />
            <input className="form-control" style={{ maxWidth: 180 }} placeholder="channel scope (optional)" value={scope} onChange={(e) => setScope(e.target.value)} />
            <button className="btn btn-theme" disabled={!code || !val} onClick={create}>Create</button>
          </div>
        </CardBody>
      </Card>

      <Card>
        <CardBody>
          {adminLoading ? <div className="text-center py-3">Loading…</div> : null}
          <table className="table table-hover align-middle mb-0">
            <thead><tr><th>Code</th><th>Type</th><th>Value</th><th>Channel</th><th>Active</th></tr></thead>
            <tbody>
              {adminVouchers.map((v) => (
                <tr key={v.code}>
                  <td className="fw-bold">{v.code}</td>
                  <td>{v.kind}</td>
                  <td>{shown(v)}</td>
                  <td>{v.channelScope || "all"}</td>
                  <td>
                    <label className="form-check form-switch mb-0">
                      <input className="form-check-input" type="checkbox" checked={v.active} onChange={() => dispatch(setVoucherActive(v.code, !v.active))} />
                    </label>
                  </td>
                </tr>
              ))}
              {!adminLoading && adminVouchers.length === 0 ? <tr><td colSpan="5" className="text-center text-inverse text-opacity-50 py-3">No vouchers yet.</td></tr> : null}
            </tbody>
          </table>
        </CardBody>
      </Card>
    </div>
  );
}
